import { combineReducers } from 'redux';
import {
  LOAD_PAIRS,
  LOAD_PERFORMACE,
  LOAD_PERFORMACE_DATES,
  SET_INDEX,
  SET_PAIR,
  SET_DATE,
  SET_PERIOD,
  SET_CATEGORY,
  SET_SORT,
  SORT_DATA,
  SET_URL_DATE,
  SET_URL_CATEGORY,
  SET_URL_PERIOD,
  SET_CURRENT_URL,
  SET_LOADER,
} from '../actions';

const performance = (state = {}, action) => {
  switch (action.type) {
    case SET_LOADER:
      return { ...state, loading: action.payload };
    case LOAD_PAIRS:
      return Object.assign({}, state, {
        pairs: action.payload,
      });
    case LOAD_PERFORMACE:
      if (!action.payload || action.payload.length === 0) {
        return {
          ...state,
          data: [],
          categories: [],
          category: '',
          categoryData: {},
          period: '',
          sortColumn: '',
          sortDirection: '',
          periodData: [],
          urlCategory: '',
          urlPeriod: '',
        };
      }

      let category = 'Sector';
      let urlPeriod = 'SI';
      const urlCategory = state.urlCategory;

      if (state.urlCategory !== 'Sector') {
        category = state.urlCategory;
      }

      let categories = action.payload.map(entity => entity.name);
      let catdata = getCategoryData(action.payload, category);
      let period = getEarliestPeriod(catdata.periods);

      if (period === 'SI') {
        if (state.urlPeriod !== 'SI') {
          period = state.urlPeriod;
        }
      }
      if (period !== 'SI') {
        urlPeriod = period;
      }

      return Object.assign({}, state, {
        data: action.payload,
        categories: categories,
        category: category,
        categoryData: catdata,
        period: period,
        sortColumn: 'Total',
        sortDirection: 'DESC',
        periodData: getPeriodData(catdata.periods, period),
        urlCategory: urlCategory,
        urlPeriod: urlPeriod,
      });
    case LOAD_PERFORMACE_DATES:
      let dates = action.payload;
      let latest = new Date(dates[dates.length - 1].asOfDate)
        .toISOString()
        .replace('-', '')
        .split('T')[0]
        .replace('-', '');
      return Object.assign({}, state, {
        dates: dates,
        date: latest,
      });
    case SET_INDEX:
      let benchmarks = state.pairs.filter(function (value) {
        return value.index === action.payload;
      });
      benchmarks.forEach(function (value, index) {
        if (value.index === 'WTMEI') {
          if (value.benchmark.indexOf('RUMIDCAP') > -1) {
            benchmarks.unshift(value);
          }
        } else if (value.index === 'WTSEI') {
          if (value.benchmark.indexOf('RU2000') > -1) {
            benchmarks.unshift(value);
          }
        } else if (value.index === 'WTMDI') {
          if (value.benchmark.indexOf('RMIDVL') > -1) {
            benchmarks.unshift(value);
          }
        } else if (value.index === 'WTSDI') {
          if (value.benchmark.indexOf('RU2000V') > -1) {
            benchmarks.unshift(value);
          }
        } else if (value.index === 'WTDI') {
          if (value.benchmark.indexOf('RU3000V') > -1) {
            benchmarks.unshift(value);
          }
        } else if (value.index === 'WTHYE') {
          if (value.benchmark.indexOf('RU1000V') > -1) {
            benchmarks.unshift(value);
          }
        } else if (value.index === 'WTLDI') {
          if (value.benchmark.indexOf('RU1000V') > -1) {
            benchmarks.unshift(value);
          }
        } else if (value.index === 'WTISDI') {
          if (value.benchmark.indexOf('MXEASC') > -1) {
            benchmarks.unshift(value);
          }
        } else if (value.index === 'WTESC') {
          if (value.benchmark.indexOf('MXEU000S') > -1) {
            benchmarks.unshift(value);
          }
        } else if (value.index === 'WTJSC') {
          if (value.benchmark.indexOf('MXJPSJPY') > -1) {
            benchmarks.unshift(value);
          }
        } else if (value.index === 'WTEMSC') {
          if (value.benchmark.indexOf('MXEFSC') > -1) {
            benchmarks.unshift(value);
          }
        } else if (value.index === 'WTIMDI') {
          if (value.benchmark.indexOf('MXEAMC') > -1) {
            benchmarks.unshift(value);
          }
        }
      });
      return Object.assign({}, state, {
        index: action.payload,
        pair: benchmarks[0],
      });
    case SET_PAIR:
      let pairData = state.pairs.filter(function (value) {
        return value.uu_attribution_id === action.payload;
      });
      return Object.assign({}, state, {
        pair: pairData[0],
      });
    case SET_DATE:
      return Object.assign({}, state, {
        date: action.payload,
      });
    case SET_CATEGORY:
      let newCatData = getCategoryData(state.data, action.payload);
      let defSort = getDefaultSort(action.payload);
      let sortColumn = defSort[0];
      let sortDirection = defSort[1];
      return Object.assign({}, state, {
        category: action.payload,
        categoryData: newCatData,
        periodData: getPeriodData(newCatData.periods, state.period),
        sortColumn: sortColumn,
        sortDirection: sortDirection,
      });
    case SET_PERIOD:
      return Object.assign({}, state, {
        period: action.payload,
        periodData: getPeriodData(state.categoryData.periods, action.payload),
      });
    case SET_SORT:
      let column = action.column;
      let direction = state.sortDirection;
      if (column === '') {
        direction = '';
      } else if (column === state.sortColumn) {
        direction = state.sortDirection === 'ASC' ? 'DESC' : 'ASC';
      } else {
        direction = 'ASC';
      }
      return Object.assign({}, state, {
        sortColumn: column,
        sortDirection: direction,
      });
    case SORT_DATA:
      let sortedData = state.periodData;
      if (state.sortColumn === 'Category') {
        sortedData = state.periodData.sort((a, b) =>
          a[state.sortColumn].localeCompare(b[state.sortColumn])
        );
      } else {
        sortedData = state.periodData.sort(
          (a, b) => a[state.sortColumn] - b[state.sortColumn]
        );
      }
      let total = null;
      let na = null;
      let tenth = null;
      sortedData = sortedData.filter(function (value) {
        if (value.Category === 'Total') {
          total = value;
          return false;
        } else if (value.Category === 'N/A') {
          na = value;
          return false;
        } else if (value.Category.startsWith('10th Decile')) {
          tenth = value;
          return false;
        } else {
          return true;
        }
      });
      if (tenth) {
        sortedData.push(tenth);
      }
      if (state.sortDirection === 'DESC') {
        sortedData.reverse();
      }
      if (na) {
        sortedData.push(na);
      }
      if (total) {
        sortedData.push(total);
      }
      return Object.assign({}, state, {
        periodData: sortedData,
      });
    case SET_URL_DATE:
      return Object.assign({}, state, {
        urlDate: action.payload,
      });
    case SET_URL_CATEGORY:
      return Object.assign({}, state, {
        urlCategory: action.payload,
      });
    case SET_URL_PERIOD:
      return Object.assign({}, state, {
        period: action.payload,
        urlPeriod: action.payload,
      });
    case SET_CURRENT_URL:
      return Object.assign({}, state, {
        currentURL: action.payload,
      });
    default:
      return state;
  }
};

function getDefaultSort(category) {
  switch (category) {
    case 'Sector':
    case 'Country':
      return ['Total', 'DESC'];
    case 'Size':
      return ['Category', 'ASC'];
    default:
      return ['Category', 'ASC'];
  }
}

function getCategoryData(data, category) {
  let categoryData = data.filter(function (value) {
    return value.name === category;
  });
  return categoryData[0];
}

function getEarliestPeriod(data) {
  let period = 'SI';
  let periods = ['SI', 'MTD', 'QTD', 'YTD', '1y', '3y', '5y', '10y'];
  for (let index = 0; index < periods.length; index++) {
    let result = checkForPeriodData(data, periods[index]);
    if (result) {
      period = periods[index];
      break;
    }
  }
  return period;
}

function checkForPeriodData(data, period) {
  let periodData3 = data.filter(function (value) {
    return value.name === period;
  });
  return periodData3[0] ? true : false;
}

/*
function getMTDorQTD(data) {
  let periodData3 = data.filter(
    function (value) {
      return value.name === 'MTD';
    }
  );
  return periodData3[0] ? 'MTD' : 'QTD';
}
*/

function getPeriodData(data, period) {
  let periodData3 = data.filter(function (value) {
    return value.name === period;
  });
  return periodData3[0].data;
}

const rootReducer = combineReducers({
  performance,
});

export default rootReducer;
